<template>
  <div class="download-results">
    {{numResults}} 
      {{hebrew ? 'אזכורים נמצאו' : 'Result(s)'}}
      <button id="downloadResultsBttn" class="btn btn-secondary" v-bind:class="{'mr-1': hebrew, 'ml-1': !hebrew}" @click="downloadResults" :disabled="numResults < 1">
        <i class="fa fa-download" aria-hidden="true"></i>
        {{hebrew ? 'הורדה' : 'Download'}}
      </button>
  </div>
</template>

<script>
import {Actions} from '@/store/stateChanges'
export default {
  name: 'DownloadResults',
  data() {
    return {
     
    };
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    numResults: function() {
        return this.$store.state.selectedResults.length
    }
  },
  methods: {
    downloadResults() {
      this.$store.dispatch(Actions.DOWNLOAD_RESULTS) 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
